require('latest-createjs');

class CaruselWrapper {
    constructor(target) {
        this.touchElement = document.createElement('div');
        this.touchElement.className = 'canvas__touch';

        this.touchElement2 = document.createElement('div');
        this.touchElement2.className = 'canvas__touch2';

        this.wrapper = document.createElement('div');
        this.wrapper.className = 'canvas__wrapper';

        this.canvas = document.createElement('canvas');

        this.content = document.createElement('div');
        this.content.className = 'canvas__content';

        this.wrapper.appendChild(this.canvas);
        this.wrapper.appendChild(this.content);
        this.touchElement2.appendChild(this.wrapper);
        this.touchElement.appendChild(this.touchElement2);

        target.appendChild(this.touchElement);

        
        let resizeHandler = () => {
            // console.log(this.wrapper);
            if (!window.detectmob()) {
                this.wrapper.style.width =  window.innerWidth + 'px';
                this.wrapper.style.height =  window.innerWidth + 'px';
                this.canvas.style.top = -(window.innerWidth - window.innerHeight) / 2 + 'px';
            } else {

                if (window.innerWidth < window.innerHeight) {
                    this.canvas.style.top = -(window.innerWidth - window.innerHeight / 2) / 2 + 'px';                
                }
            }
            
        };
        
        resizeHandler();
        if (!window.detectmob()) {
            this.canvas.setAttribute('width', this.wrapper.offsetWidth);
            this.canvas.setAttribute('height', this.wrapper.offsetWidth);
        } else {
            this.canvas.setAttribute('width', '520px');
            this.canvas.setAttribute('height', '520px');
        }

        window.addEventListener('resize', resizeHandler);
    }
}

class Carusel {
    constructor(target) {
        this.caruselWrapper = new CaruselWrapper(target);
        this._ticks = [];

        // this.stage = new window.createjs.Stage(this.caruselWrapper.canvas);
        
        this.stage = new window.createjs.StageGL(this.caruselWrapper.canvas, { antialias: true, transparent: true });
        this._tick = event => {
            this._ticks.forEach(item => {
                item.call(null, event, this.stage);
            });
            this.stage.update(event);
        };

        this.stage.mouseChildren = false;
        this.stage.mouseEnabled = false;
        this.stage.snapToPixelEnabled = true;

        window.createjs.Ticker.timingMode = window.createjs.Ticker.RAF;
        window.createjs.Ticker.framerate = 40;
        window.createjs.Ticker.addEventListener("tick", this._tick);
    }
    get touchElement() {
        return this.caruselWrapper.touchElement;
    }
    get touchElement2() {
        return this.caruselWrapper.touchElement2;
    }
    get wrapper() {
        return this.caruselWrapper.wrapper;
    }
    init(callback) {
        if (typeof callback === 'function') {
            callback.call(null, this.stage, this.caruselWrapper);
        }
    }
    tick(callback) {
        if (typeof callback === 'function') {
            this._ticks.push(callback);
        }
    }
}


module.exports = Carusel;


// WEBPACK FOOTER //
// ./js/carusel.js